
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.828 9.147l-3.71-3.673L9.79 1.769 8.647.635 4.976 4.342 1.27.672.135 1.807l3.71 3.677L.172 9.193l1.135 1.135 3.68-3.713 3.707 3.675 1.134-1.143z","fill":"#161619"}})])
          )
        }
      }
    